import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "about main_container" }
const _hoisted_2 = { class: "section1" }
const _hoisted_3 = { class: "container" }
const _hoisted_4 = { class: "top" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "公司简介", -1)
const _hoisted_6 = { class: "picContainer" }
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, [
  /*#__PURE__*/_createElementVNode("p", null, " 南京元感微电子有限公司成立于 2017 年，是一家专注于 MEMS 传感芯片、MEMS 传感器模组设计及制造的国家高新技术企业。公司秉持创新驱动发展的理念，致力于实现 MEMS 芯片及相关技术的全自主知识产权覆盖，打破国外技术垄断，推动国内 MEMS 传感技术的自主可控发展。 "),
  /*#__PURE__*/_createElementVNode("p", null, " 公司采用 Fabless 运营模式，凭借深厚的技术积累和创新能力，在压力、力（EMB刹车力）、IMU/惯性、气体、流量等 MEMS 芯片设计方面取得了显著成就。公司研发团队拥有 20 年以上国际先进水平的 MEMS 传感芯片设计制造经验，成功完成超过 30 种 MEMS 芯片的设计流片，技术水平达到国际先进水准。公司核心产品涵盖消费级和工业级 MEMS 传感器，广泛应用于工业自动化、汽车电子、航空航天、机器人、无人机、无人驾驶、锂电安全、核工业、白色家电、医疗等多个关键领域，为各行业的智能化升级和发展提供了坚实的技术支持。 ")
], -1)
const _hoisted_9 = { class: "wechat" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "section2" }
const _hoisted_12 = { class: "device" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "title a-title" }, "公司资质及证书", -1)
const _hoisted_14 = { class: "container" }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = {
  class: "image",
  alt: "item.content"
}
const _hoisted_17 = { class: "name" }
const _hoisted_18 = { class: "container" }
const _hoisted_19 = { class: "content" }
const _hoisted_20 = {
  class: "image",
  alt: "item.content"
}
const _hoisted_21 = { class: "c-name" }
const _hoisted_22 = { class: "section3" }
const _hoisted_23 = { class: "patent" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "title a-title" }, "发明专利", -1)
const _hoisted_25 = { class: "content" }
const _hoisted_26 = {
  class: "image",
  alt: "元感微发明专利"
}
const _hoisted_27 = { class: "section3-1" }
const _hoisted_28 = { class: "patent" }
const _hoisted_29 = { class: "content" }
const _hoisted_30 = {
  class: "image",
  alt: "元感微发明专利"
}
const _hoisted_31 = { class: "section3-2" }
const _hoisted_32 = { class: "patent" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "title a-title" }, "实用新型专利", -1)
const _hoisted_34 = { class: "content" }
const _hoisted_35 = {
  class: "image",
  alt: "元感微实用新型专利"
}
const _hoisted_36 = { class: "section3-3" }
const _hoisted_37 = { class: "patent" }
const _hoisted_38 = { class: "content" }
const _hoisted_39 = {
  class: "image",
  alt: "元感微实用新型专利"
}
const _hoisted_40 = { class: "section3-4" }
const _hoisted_41 = { class: "patent" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "title a-title" }, "集成电路布图设计", -1)
const _hoisted_43 = { class: "content" }
const _hoisted_44 = {
  class: "image",
  alt: "元感微集成电路布图设计"
}
const _hoisted_45 = { class: "section3-5" }
const _hoisted_46 = { class: "patent" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "title soft-title a-title" }, "软件著作权", -1)
const _hoisted_48 = { class: "content" }
const _hoisted_49 = {
  class: "image",
  alt: "元感微软件著作权"
}
const _hoisted_50 = { class: "section4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "title cp-title" }, "公司合作伙伴", -1)
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "grid-container" }, null, -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = { class: "section5" }

import { ref, reactive, onMounted, onUnmounted } from "vue";
import QrCode from "@/components/QrCode.vue";
import Footer from "@/components/Footer.vue";
import "../styles/about.scss"; // 引入css样式文件
import GreatEvent from "@/components/greatEvents.vue"; // 引入大事记组件


export default /*#__PURE__*/_defineComponent({
  __name: 'AboutView',
  setup(__props) {

const isHighRes = ref(window.innerWidth >= 3840);

// let img = require("@/assets/wechat1.png"); // 公众号二维码
let img = require("@/assets/icons/publicQrCode.svg");

// let aboutLogo = require("@/assets/images/logo-white.png"); // logo
let aboutLogo = require("@/assets/icons/LOGO.svg");

let mapImg = require("@/assets/images/map.png");
let mapImgHd = require("@/assets/images/map-hd.png");

const gutter = ref(40); // 3 3-1 3-2 3-3 3-5的gutter默认值
const circuitGutter = ref(60); // 3-4的gutter默认值

// 更新gutter值以响应窗口大小变化
function updateGutter() {
  gutter.value = window.innerWidth < 768 ? 20 : 40;
  circuitGutter.value = window.innerWidth < 768 ? 10 : 60;
}

onMounted(() => {
  updateGutter(); // 初始检查
  window.addEventListener("resize", updateGutter); // 监听窗口大小变化
});

onUnmounted(() => {
  window.removeEventListener("resize", updateGutter); // 组件销毁时移除监听器
});

let qualificationList = reactive([
  {
    imgSrc: require("@/assets/images/q2.jpg"),
    content: "质量管理体系认证证书",
  },
  {
    imgSrc: require("@/assets/images/q3.jpg"),
    content: "环境管理体系认证证书",
  },
  {
    imgSrc: require("@/assets/images/q4.jpg"),
    content: "职业健康安全管理体系认证证书",
  },
  {
    imgSrc: require("@/assets/images/q5.jpg"),
    content: "南京市知识产权示范企业",
  },
]);

let certificateList = reactive([
  {
    imgSrc: require("@/assets/images/q6.jpg"),
    content: "高新技术企业",
  },
  {
    imgSrc: require("@/assets/images/q7.jpg"),
    content: "AAA级信用企业",
  },
  {
    imgSrc: require("@/assets/images/q8.jpg"),
    content: "江苏省民营科技企业",
  },
]);

// 发明专利
let patentList1 = reactive([
  require("@/assets/images/z1.jpg"),
  require("@/assets/images/z2.jpg"),
  require("@/assets/images/z3.jpg"),
  require("@/assets/images/z4.jpg"),
  require("@/assets/images/z5.jpg"),
  require("@/assets/images/z6.jpg"),
  require("@/assets/images/z7.jpg"),
  // require("@/assets/images/z8.png"),
  // require("@/assets/images/z9.png"),
  // require("@/assets/images/z11.png"),
  // require("@/assets/images/z12.png"),
  require("@/assets/images/z8.jpg"),
  require("@/assets/images/z9.jpg"),
  require("@/assets/images/z10.jpg"),
  require("@/assets/images/z11.jpg"),
  require("@/assets/images/z12.jpg"),
]);

let patentList2 = reactive([
  require("@/assets/images/z13.jpg"),
  require("@/assets/images/z14.jpg"),
  require("@/assets/images/z15.jpg"),
  require("@/assets/images/z16.jpg"),
  require("@/assets/images/z17.jpg"),
  require("@/assets/images/z18.jpg"),
  require("@/assets/images/z19.jpg"),
  require("@/assets/images/z20.jpg"), // 快到期的专利，之后需要撤图
  require("@/assets/images/z21.jpg"),
]);

// 实用新型专利
let utilityModelPatents1 = reactive([
  require("@/assets/images/s1.jpg"),
  require("@/assets/images/s2.jpg"),
  require("@/assets/images/s3.jpg"),
  require("@/assets/images/s4.jpg"),
  require("@/assets/images/s5.jpg"),
  require("@/assets/images/s6.jpg"),
  require("@/assets/images/s7.jpg"),
  require("@/assets/images/s8.jpg"),
  require("@/assets/images/s9.jpg"),
  require("@/assets/images/s10.jpg"),
  require("@/assets/images/s11.jpg"),
  require("@/assets/images/s12.jpg"),
]);

let utilityModelPatents2 = reactive([
  require("@/assets/images/s13.jpg"),
  require("@/assets/images/s14.jpg"),
  require("@/assets/images/s15.jpg"),
]);

// 集成电路布局设计
let circuitLayoutDesign1 = reactive([
  require("@/assets/images/j1.jpg"),
  require("@/assets/images/j2.jpg"),
  require("@/assets/images/j3.jpg"),
  require("@/assets/images/j4.jpg"),
  require("@/assets/images/j5.jpg"),
  require("@/assets/images/j6.jpg"),
  require("@/assets/images/j7.jpg"),
  require("@/assets/images/j8.jpg"),
  require("@/assets/images/j9.jpg"),
  require("@/assets/images/j10.jpg"),
  require("@/assets/images/j11.jpg"),
  require("@/assets/images/j12.jpg"),
]);

let circuitLayoutDesign2 = reactive([
  require("@/assets/images/j9.jpg"),
  require("@/assets/images/j10.jpg"),
  require("@/assets/images/j11.jpg"),
  require("@/assets/images/j12.jpg"),
]);

// 软著
let softwareCopyright = reactive([
  require("@/assets/images/r1.jpg"),
  require("@/assets/images/r2.jpg"),
  require("@/assets/images/r3.jpg"),
  require("@/assets/images/r4.jpg"),
  require("@/assets/images/r6.jpg"),
  require("@/assets/images/r7.jpg"),
]);

// 控制二维码的显示与隐藏，默认是展示二维码
const showQRCode = ref<boolean>(true);
// 🧫🐤🐤🐤🐤🐤
const showFooter = ref<boolean>(true); // 控制底部Footer的显隐

onMounted(() => {
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.5,
  };

  // 观察元素 IntersectionObserver API
  // 页面的第一屏不展示二维码，其他屏都展示
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      // 如果被观察的元素`section1`进入了视口
      if (entry.target.classList.contains("section1")) {
        showQRCode.value = !entry.isIntersecting;
      }
    });
  }, options);

  const section1 = document.querySelector(".section1"); // 获取DOM元素

  if (section1) {
    observer.observe(section1); // 开始观察class为"section1"的元素
  }

  // 🧫🐤🐤🐤🐤🐤  页面的最后一屏才显示Footer组件
  const observerIsFooter = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target.classList.contains("section5")) {
        showFooter.value = entry.isIntersecting; // 第五屏 section5 显示底部Footer
      }
    });
  }, options);

  const section5 = document.querySelector(".section5"); // 获取元素
  if (section5) {
    observerIsFooter.observe(section5);
  }
});

// 🐸🐸🐸🐸🐸🐸🐸🐸
// 定义适配函数
const reScreenSize = () => {
  let w = document.documentElement.clientWidth;
  let newFontSize = 10 * (w / 1920);
  newFontSize = Math.max(7.4, Math.min(newFontSize, 40));
  document.documentElement.style.fontSize = `${newFontSize}px`;
};

// 页面加载时执行一次适配
onMounted(() => {
  reScreenSize();
  window.addEventListener("resize", reScreenSize);
});

// 页面卸载时移除监听事件
onUnmounted(() => {
  window.removeEventListener("resize", reScreenSize);
});

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_lazy = _resolveDirective("lazy")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(QrCode, { showQRCode: showQRCode.value }, null, 8, ["showQRCode"]),
    _createVNode(Footer, { showFooter: showFooter.value }, null, 8, ["showFooter"]),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: _unref(aboutLogo),
              alt: "元感微电子logo"
            }, null, 8, _hoisted_7)
          ])
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("img", {
            src: _unref(img),
            alt: "南京元感微公众号二维码"
          }, null, 8, _hoisted_10)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: 20
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qualificationList), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                span: 6,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _withDirectives(_createElementVNode("img", _hoisted_16, null, 512), [
                        [_directive_lazy, item.imgSrc]
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.content), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }),
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: 20
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(certificateList), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                span: 8,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _withDirectives(_createElementVNode("img", _hoisted_20, null, 512), [
                        [_directive_lazy, item.imgSrc]
                      ])
                    ]),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(item.content), 1)
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("section", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _hoisted_24,
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: gutter.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patentList1), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 6,
                sm: 4,
                md: 4,
                lg: 4,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_25, [
                    _withDirectives(_createElementVNode("img", _hoisted_26, null, 512), [
                      [_directive_lazy, item]
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["gutter"])
      ])
    ]),
    _createElementVNode("section", _hoisted_27, [
      _createElementVNode("div", _hoisted_28, [
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: gutter.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patentList2), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 6,
                sm: 4,
                md: 4,
                lg: 4,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("img", _hoisted_30, null, 512), [
                      [_directive_lazy, item]
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["gutter"])
      ])
    ]),
    _createElementVNode("section", _hoisted_31, [
      _createElementVNode("div", _hoisted_32, [
        _hoisted_33,
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: gutter.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(utilityModelPatents1), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 6,
                sm: 4,
                md: 4,
                lg: 4,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_34, [
                    _withDirectives(_createElementVNode("img", _hoisted_35, null, 512), [
                      [_directive_lazy, item]
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["gutter"])
      ])
    ]),
    _createElementVNode("section", _hoisted_36, [
      _createElementVNode("div", _hoisted_37, [
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: gutter.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(utilityModelPatents2), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 6,
                sm: 4,
                md: 4,
                lg: 4,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_38, [
                    _withDirectives(_createElementVNode("img", _hoisted_39, null, 512), [
                      [_directive_lazy, item]
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["gutter"])
      ])
    ]),
    _createElementVNode("section", _hoisted_40, [
      _createElementVNode("div", _hoisted_41, [
        _hoisted_42,
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: circuitGutter.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(circuitLayoutDesign1), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 8,
                sm: 6,
                md: 6,
                lg: 6,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_43, [
                    _withDirectives(_createElementVNode("img", _hoisted_44, null, 512), [
                      [_directive_lazy, item]
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["gutter"])
      ])
    ]),
    _createElementVNode("section", _hoisted_45, [
      _createElementVNode("div", _hoisted_46, [
        _hoisted_47,
        _createVNode(_component_el_row, {
          class: "cardContainer",
          gutter: gutter.value
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(softwareCopyright), (item) => {
              return (_openBlock(), _createBlock(_component_el_col, {
                xs: 8,
                sm: 4,
                md: 4,
                lg: 4,
                key: item
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _withDirectives(_createElementVNode("img", _hoisted_49, null, 512), [
                      [_directive_lazy, item]
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        }, 8, ["gutter"])
      ])
    ]),
    _createElementVNode("section", _hoisted_50, [
      _hoisted_51,
      _createElementVNode("div", {
        class: "partners",
        style: _normalizeStyle({
          backgroundImage: `url(${isHighRes.value ? _unref(mapImgHd) : _unref(mapImg)})`,
        })
      }, _hoisted_53, 4)
    ]),
    _createElementVNode("section", _hoisted_54, [
      _createVNode(GreatEvent)
    ])
  ]))
}
}

})